/* global angular swal */

import './style.less';
import { orderBy, get } from 'lodash';

export default function($log, $scope, $stateParams, $state, ApiClass, ProfileClass) {
  'ngInject';

  const vm = this;
  vm.profileUid = $stateParams.id;
  vm.$onInit = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  vm.archive = ngSponsor => {
    const sponsor = angular.copy(ngSponsor);

    ApiClass.companiesIdTypeTypeIdPatch(
      { manage: true, id: company_id, type: 'sponsors', type_id: sponsor.sponsor_id },
      { archived: true }
    )
      .then(response => {
        $log.debug(response);
        vm.sponsors.splice(vm.sponsors.indexOf(ngSponsor), 1);
      })
      .catch(error => {
        swal('Oops', `Can't archive ${ngSponsor.name || 'sponsor'} at this time`, 'error');
        sponsor.archived = false;
        $log.error(error);
        throw error;
      });
  };

  vm.create = () => {
    ApiClass.companiesIdTypePut({ manage: true, id: company_id, type: 'sponsors' }, { sponsor: {} })
      .then(({ data: { item } }) => {
        $log.debug(arguments);
        const stateParams = angular.copy($stateParams);
        stateParams.sponsor_id = item.sponsor_id;
        $state.go('app.admin.sponsors.sponsor', stateParams);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.previewPdf = sponsor_id => {
    ApiClass.companiesIdTypeTypeIdSubTypeGet({
      manage: true,
      id: company_id,
      type: 'sponsors',
      type_id: sponsor_id,
      sub_type: 'preview'
    })
      .then(({ data }) => {
        const pdfURI = encodeURI(data);
        const pdfWindow = window.open('');

        pdfWindow.document.write(`<iframe width='100%' height='100%' src='${pdfURI}'></iframe>"`);
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  vm.duplicate = sponsor_id => {
    ApiClass.companiesIdTypePut(
      {
        manage: true,
        id: company_id,
        type: 'sponsors'
      },
      { sponsor: { sponsor_id }, copy: true }
    )
      .then(({ data: { item } }) => {
        const stateParams = angular.copy($stateParams);
        stateParams.sponsor_id = item.sponsor_id;
        $state.go('app.admin.sponsors.sponsor', stateParams);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  function activate() {
    ApiClass.companiesIdTypeGet({ manage: true, id: company_id, type: 'sponsors' }, null)
      .then(({ data: { items: sponsors } }) => {
        $log.debug(arguments);
        $scope.disableButtons = get(ProfileClass, 'profileComplete.company.preferences.read_only.admin.sponsorManager', false);
        vm.sponsors = orderBy(sponsors, ['name', 'active'], ['asc', 'desc']).filter(({ archived }) => !archived);
        vm.loaded = true;
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/controllers/admin/sponsors/get/index.js